module.exports = __webpack_public_path__ + "static/gallery-img-31-6678969f8078d09cc7c4fcb193050d5d.jpg";